/* eslint-disable react-hooks/exhaustive-deps */
import { InputText } from "primereact/inputtext";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { DataTable, DataTableFilterMeta, DataTableSelectionSingleChangeEvent } from "primereact/datatable";
import { Column, ColumnEditorOptions } from "primereact/column";
import { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Toast } from "primereact/toast";
import { classNames } from 'primereact/utils';
import { Panel } from "primereact/panel";
import { Button } from "primereact/button";
import React from "react";
import { Dialog } from "primereact/dialog";
import { Link } from "react-router-dom";
import MinGroup from "../../models/MinGroup";
import { useMsal } from "@azure/msal-react";
import MaintenanceService from "../../service/MaintenanceService";
import autoTable from "jspdf-autotable";
import { FilterMatchMode, FilterOperator } from "primereact/api";

const defaultFilters: DataTableFilterMeta = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    minGroupDesc: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    minGroupUpdTs: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    minGroupUpdUser: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    }
};

export default function MinGroupView() {
    let empty: MinGroup = {
        minGroupId: 0,
        minGroupDesc: '',
        minGroupTimstp: '',
        minGroupUpdUser: '',
        minGroupUpdTs: ''
    };

    const [listValues, setListValues] = useState<MinGroup[]>([]);
    const [listFilteredData, setListFilteredData] = useState<MinGroup[]>([]);
    const [singleValue, setSingleValue] = useState<MinGroup>(empty);
    const [loading, setLoading] = useState(true);
    const [globalFilter, setGlobalFilter] = useState<string>('');
    const isNew = useRef(false);
    const form = useForm();
    const formEdit = useForm({ mode: "onChange" });
    const [editingRows, setEditingRows] = useState({});
    const errors = form.formState.errors;
    const toast = useRef<any>(null);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const { accounts } = useMsal();
    const [updateTrigger, setUpdateTrigger] = useState(0);
    const dt = useRef<any>(null);

    useEffect(() => {
        initFilters();
        MaintenanceService.getMinGroups().then(data => {
            setListValues(data);
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        MaintenanceService.getMinGroups().then(data => {
            setListValues(data);
            setLoading(false);
        });
    }, [updateTrigger]);

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const getFilteredData = () => {
        const data = listFilteredData.length > 0 ? listFilteredData : dt.current.props.value;

        const bodyData = data.map((item: MinGroup) => [
            item.minGroupDesc,
            item.minGroupUpdTs,
            item.minGroupUpdUser
        ]);

        return bodyData;
    };

    const exportPdf = () => {
        const bodyData = getFilteredData();
        import('jspdf').then((jsPDF) => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default("l");
                autoTable(doc, { head: [['Description', 'Last Update Date', 'Last Update User']], body: bodyData })
                doc.save('mingroups.pdf');
            });
        });
    };

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilter(value);
    };

    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);
    const initFilters = () => {
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = null;
        setFilters(defaultFilters);
        setGlobalFilter('');
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <div>
                <i className="pi pi-file-excel ml-3 text-green-500 cursor-pointer" title="Export CSV" onClick={(e) => { exportCSV(); e.stopPropagation(); }} />
                <i className="pi pi-file-pdf ml-3 text-red-500 cursor-pointer" title="Export PDF" onClick={(e) => { exportPdf(); e.stopPropagation(); }} />
            </div>
            <IconField iconPosition="left">
                <InputIcon className="pi pi-search" />
                <InputText className="p-inputtext-sm" type="search" autoComplete="off" value={globalFilter} onChange={onGlobalFilterChange} placeholder="Search..." />
            </IconField>
        </div>
    );

    const minGroupIdTemplate = (rowData: MinGroup) => {
        return rowData.minGroupId;
    }

    const minGroupDescTemplate = (rowData: MinGroup) => {
        return rowData.minGroupDesc;
    }

    const minGroupUpdTsTemplate = (rowData: MinGroup) => {
        return rowData.minGroupUpdTs;
    }

    const minGroupUpdUserTemplate = (rowData: MinGroup) => {
        return rowData.minGroupUpdUser;
    }

    const clearNew = () => {
        form.reset();
    }

    const getErrorMessage = (name: string) => {
        return errors[name] ? <small className="p-error">{(errors[name] as any).message}</small> : <small className="p-error">&nbsp;</small>;
    };

    const onSubmit = (data: any) => {
        isNew.current = true;
        let _value = { ...singleValue };
        _value.minGroupDesc = data.minGroupDesc;

        if (accounts[0]) {
            _value.minGroupUpdTs = new Date().toISOString();
            _value.minGroupUpdUser = accounts[0].username.split('@')[0];
        }

        save(_value);
        form.reset();
    };

    const save = (value: MinGroup) => {
        if (isNew.current) {
            MaintenanceService.addMinGroup(value).then((data) => {
                if (data) {
                    setUpdateTrigger(prev => prev + 1);
                    toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Min Group Created', life: 3000 });
                    setSingleValue(empty);
                } else {
                    toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Create Min Group', life: 3000 });
                }
            });
        } else {
            MaintenanceService.updateMinGroup(value).then(() => {
                setUpdateTrigger(prev => prev + 1);
                toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Min Group Updated', life: 3000 });
                setSingleValue(empty);
            }).catch(() => {
                toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to Update Min Group', life: 3000 });
            });
        }
    }

    const setActiveRowIndexCE = (rowData: DataTableSelectionSingleChangeEvent<MinGroup[]>) => {
        let selectedIndex = listValues.findIndex(v => v.minGroupId === (rowData.value as MinGroup).minGroupId);
        let _editingRows = { ...editingRows, ...{ [`${listValues[selectedIndex].minGroupId}`]: true } };
        if (Object.keys(_editingRows).length === 1) {
            setEditingRows(_editingRows);
        }
    }

    const onRowEditChange = (e: any) => {
        setEditingRows(e.data);
    }

    const onRowEditComplete = (e: any) => {
        let _listValues = [...listValues];
        let { newData } = e;
        let index = listValues.findIndex(v => v.minGroupId === newData.minGroupId);
        _listValues[index] = newData;

        setListValues(_listValues);
    }

    const cellEditor = (options: ColumnEditorOptions) => {
        switch (options.field) {
            case 'minGroupDesc':
                return minGroupDescEditor(options);
        }
    }

    const minGroupDescEditor = (options: any) => {
        return (
            <Controller
                name="minGroupDescEdit"
                control={formEdit.control}
                defaultValue={options.value}
                rules={{
                    required: 'Description is required.',
                    maxLength: {
                        value: 25,
                        message: 'Description must be at most 25 characters.',
                    },
                }}
                render={({ field, fieldState }) => {
                    singleValue.minGroupDesc = field.value;
                    return (
                        <>
                            <InputText ref={field.ref} value={fieldState.isDirty ? field.value : options.value} maxLength={25} tooltip={fieldState.error?.message} tooltipOptions={{ position: 'bottom' }} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => { singleValue.minGroupDesc = e.target.value; field.onChange(e.target.value.toUpperCase()); }} placeholder="Description" />
                        </>
                    )
                }}
            />
        );
    }

    const rowEditorTemplate = (rowData: MinGroup, props: any) => {
        const rowEditor = props.rowEditor;

        if (rowEditor.editing) {
            isNew.current = false;

            return (
                <>
                    <Button icon="p-row-editor-save-icon pi pi-fw pi-save" title="Save" rounded text severity="info" type="submit" onClick={(e) => {
                        if (!formEdit.getFieldState("minGroupDescEdit").invalid) {
                            let _singleValue = { ...singleValue };
                            _singleValue.minGroupId = rowData.minGroupId;

                            if (accounts[0]) {
                                _singleValue.minGroupUpdTs = new Date().toISOString();
                                _singleValue.minGroupUpdUser = accounts[0].username.split('@')[0];
                            }

                            save(_singleValue);
                            formEdit.reset();
                            rowEditor.onSaveClick(e);
                        }
                    }} />

                    <Button icon="p-row-editor-cancel-icon pi pi-fw pi-undo" title="Undo" rounded text severity="danger" onClick={(e) => {
                        formEdit.clearErrors();
                        formEdit.reset();
                        rowEditor.onCancelClick(e);
                    }} />
                </>
            );
        } else {
            return (
                <Link className="pi pi-fw pi-trash rowDelete" title="Delete" onClick={() => confirmDelete(rowData)} to={''}></Link>
            );
        }
    }

    const hideDeleteDialog = () => {
        setDeleteDialog(false);
    };

    const confirmDelete = (value: MinGroup) => {
        setSingleValue(value);
        setDeleteDialog(true);
    }

    const deleteRow = () => {
        MaintenanceService.deleteMinGroup(singleValue.minGroupId).then(() => {
            setUpdateTrigger(prev => prev + 1);
            setDeleteDialog(false);
            setSingleValue(empty);
            toast.current.show({ severity: 'success', summary: 'Successful', detail: 'Deleted', life: 3000 });
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Failed', detail: 'Failed to remove', life: 3000 });
        });

    };

    const deleteDialogFooter = (
        <React.Fragment>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={hideDeleteDialog} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={deleteRow} />
        </React.Fragment>
    );

    return (
        <>
            <Toast ref={toast} />

            <Panel header="Add Min Group" className="addPanel mb-2 -ml-2">
                <form onSubmit={form.handleSubmit(onSubmit)} className="p-fluid" autoComplete="off">
                    <div className="formgrid grid">
                        <div className="field col-4">
                            <Controller
                                name="minGroupDesc"
                                control={form.control}
                                defaultValue=""
                                rules={{
                                    required: 'Description is required.',
                                    maxLength: {
                                        value: 25,
                                        message: 'Description must be at most 25 characters.',
                                    },
                                }}
                                render={({ field, fieldState }) => (
                                    <>
                                        <label htmlFor={field.name} className="font-bold text-xs">Description</label>
                                        <InputText id={field.name} name={field.name} value={field.value} maxLength={25} className={classNames({ 'p-invalid border-left-10': fieldState.error })} onChange={(e) => field.onChange(e.target.value.toUpperCase())} placeholder="Description" />
                                        {getErrorMessage('minGroupDesc')}
                                    </>
                                )}
                            />
                        </div>
                        <div className="field field-buttons col-2 pt-4">
                            <Button icon="pi pi-save" title="Save" rounded text severity="info" type="submit" />
                            <Button icon="pi pi-undo" title="Undo" rounded text severity="danger" type="button" onClick={clearNew} />
                        </div>
                    </div>
                </form>
            </Panel>

            <DataTable ref={dt} className="-ml-2" value={listValues} selectionMode="single" onSelectionChange={setActiveRowIndexCE}
                dataKey="minGroupId" size="small" rowHover={true} loading={loading}
                scrollable scrollHeight="calc(100vh - 23.9rem)"
                paginator rows={25} rowsPerPageOptions={[5, 10, 25]} alwaysShowPaginator={false}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                editingRows={editingRows} editMode="row" onRowEditChange={onRowEditChange} onRowEditComplete={onRowEditComplete}
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                filters={filters} header={header} onValueChange={filteredData => setListFilteredData(filteredData)}
                emptyMessage="No min group records found.">
                <Column field="minGroupId" header="Minimum Group ID" sortable body={minGroupIdTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '30%', minWidth: '15rem' }}></Column>
                <Column field="minGroupDesc" header="Description" sortable body={minGroupDescTemplate} filter filterPlaceholder="Search..." editor={(options: ColumnEditorOptions) => cellEditor(options)} align="center" alignHeader="center" headerStyle={{ width: '30%', minWidth: '15rem' }}></Column>
                <Column field="minGroupUpdTs" header="Last Update Date" sortable body={minGroupUpdTsTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '20%', minWidth: '10rem' }}></Column>
                <Column field="minGroupUpdUser" header="Last Update User" sortable body={minGroupUpdUserTemplate} filter filterPlaceholder="Search..." align="center" alignHeader="center" headerStyle={{ width: '20%', minWidth: '10rem' }}></Column>
                <Column rowEditor body={rowEditorTemplate} headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
            </DataTable>

            <Dialog visible={deleteDialog} style={{ width: '32rem' }} breakpoints={{ '960px': '75vw', '641px': '90vw' }} header="Confirm" modal footer={deleteDialogFooter} onHide={hideDeleteDialog}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    {singleValue && (
                        <span>
                            Are you sure you want to delete <b>{singleValue.minGroupDesc}</b>?
                        </span>
                    )}
                </div>
            </Dialog>
        </>
    )
}
